import { render } from "./LicensingInformation.vue?vue&type=template&id=173f64ed&scoped=true"
import script from "./LicensingInformation.vue?vue&type=script&lang=js"
export * from "./LicensingInformation.vue?vue&type=script&lang=js"

import "./LicensingInformation.vue?vue&type=style&index=0&id=173f64ed&scoped=true&lang=css"

import exportComponent from "/home/rainnya_lime/桌面/project/waydro.id/Waydro.id/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173f64ed"]])

export default __exports__